class BasicResultModel {
    constructor(success = false, message = "", data = []) {
        this._success = success;
        this._message = message;
        this._data = data;
    }

    get success() {
        return this._success;
    }

    set success(value) {
        if (typeof value !== "boolean") {
            throw new Error("Success must be a boolean");
        }
        this._success = value;
    }

    get message() {
        return this._message;
    }

    set message(value) {
        if (typeof value !== "string") {
            throw new Error("Message must be a string");
        }
        this._message = value;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    toJSON() {
        return { success: this._success, message: this._message, data: this._data };
    }
}

export default BasicResultModel;